import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RouteTranslationMap } from '@rx-applications/shared/auth/data-access';
import { ContactInstructionsComponent } from '@rx-applications/shared/auth/ui';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'rx-applications-feature-info',
  standalone: true,
  imports: [CommonModule, ContactInstructionsComponent, TranslocoDirective],
  templateUrl: './info.component.html',
  styleUrl: './info.component.scss',
  providers: [translationProvider],
})
export class InfoComponent {
  readonly router = inject(Router);
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  getMessageDependingOnRoute(): string {
    const cleanPathFromUrl: string = this.getCleanPathFromUrl(this.router.url);
    return RouteTranslationMap[cleanPathFromUrl];
  }

  private getCleanPathFromUrl(url: string): string {
    return url.split('?')[0].replace(/^\/+/, '');
  }
}
